const EARTH_RADIUS_METERS = 6371008.8;
const SEARCH_RADIUS_MARGIN_METERS = 1000;
const MAX_SEARCH_RADIUS_METERS = 20000;

type LngLatBbox = [number, number, number, number];

const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

export const haversineDistanceMeters = (
  from: { lat: number; lng: number },
  to: { lat: number; lng: number },
) => {
  const dLat = toRadians(to.lat - from.lat);
  const dLng = toRadians(to.lng - from.lng);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(from.lat)) *
      Math.cos(toRadians(to.lat)) *
      Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(a));
};

const parseLngLatBbox = (raw: unknown): LngLatBbox | null =>
  Array.isArray(raw) &&
  raw.length === 4 &&
  raw.every(value => typeof value === 'number' && Number.isFinite(value))
    ? (raw as LngLatBbox)
    : null;

export const getLocalitySearchRadiusMeters = (
  places: readonly { children_bbox: unknown }[],
  lat: number | null | undefined,
  lng: number | null | undefined,
): number | null => {
  if (lat == null || lng == null || places.length === 0) {
    return null;
  }
  const origin = { lat, lng };
  let farthestCorner = 0;
  for (const place of places) {
    const bbox = parseLngLatBbox(place.children_bbox);
    if (bbox == null) {
      return null;
    }
    const [minLng, minLat, maxLng, maxLat] = bbox;
    for (const corner of [
      { lat: minLat, lng: minLng },
      { lat: minLat, lng: maxLng },
      { lat: maxLat, lng: minLng },
      { lat: maxLat, lng: maxLng },
    ]) {
      farthestCorner = Math.max(
        farthestCorner,
        haversineDistanceMeters(origin, corner),
      );
    }
  }
  const radius = farthestCorner + SEARCH_RADIUS_MARGIN_METERS;
  return radius > MAX_SEARCH_RADIUS_METERS ? null : radius;
};
